<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="flowActivityForm" :model="formData" class="full-width-input" :disable="readOnly"
      :rules="rules" style="width: 100%;"
      label-width="150px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="活动内容(50字以上)" prop="Activity.activityContent">
            <el-input class="input-item" v-if="!readOnly"    type="textarea"
                      :autosize="{minRows: 2, maxRows: 4}" v-model="formData.Activity.activityContent"
              :clearable="true" placeholder="活动内容(50字以上)"
            />
            <span class="input-item input-label" v-else>{{formData.Activity.activityContent}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="成效" prop="Activity.effect">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.Activity.effect"
              :clearable="true" placeholder="成效"
            />
            <span class="input-item input-label" v-else>{{formData.Activity.effect}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="参与人数" prop="Activity.participants">
            <el-select class="input-item" v-if="!readOnly" v-model="formData.Activity.participants" :clearable="true" filterable
              placeholder="参与人数" :loading="flowActivityForm.participants.impl.loading"
              @visible-change="flowActivityForm.participants.impl.onVisibleChange"
              @change="onParticipantsValueChange">
              <el-option v-for="item in flowActivityForm.participants.impl.dropdownList" :key="item.id"
                :value="item.id" :label="item.name"
              />
            </el-select>
            <span class="input-item input-label" v-else>{{(formData.Activity.participantsDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
<!--          <el-form-item label="现场图片" prop="Activity.siteImages">-->
<!--            <el-upload v-if="!readOnly"-->
<!--              class="upload-image-item" name="uploadFile" :headers="getUploadHeaders"-->
<!--              :action="getUploadActionUrl('/admin/app/activity/upload')"-->
<!--              :data="{fieldName: 'siteImages', asImage: true}"-->
<!--              :on-success="onSiteImagesUploadSuccess"-->
<!--              :on-remove="onSiteImagesRemoveFile"-->
<!--              :before-upload="pictureFile"-->
<!--              :on-error="onUploadError"-->
<!--  -->
<!--              :show-file-list="false">-->
<!--              <div v-if="flowActivityForm.siteImages.impl.fileList && flowActivityForm.siteImages.impl.fileList[0] != null" style="position: relative">-->
<!--                <img class="upload-image-show"-->
<!--                  :src="flowActivityForm.siteImages.impl.fileList[0].url" />-->
<!--                <div class="upload-img-del el-icon-close"-->
<!--                  @click.stop="onSiteImagesRemoveFile(null, null)" />-->
<!--              </div>-->
<!--              <i v-else class="el-icon-plus upload-image-item"></i>-->
<!--            </el-upload>-->
<!--            <template v-else>-->
<!--              <img v-for="item in flowActivityForm.siteImages.impl.fileList" :key="item.url"-->
<!--                class="table-cell-image" :src="item.url" />-->
<!--            </template>-->
<!--          </el-form-item>-->

          <el-form-item label="现场图片" prop="Activity.siteImages">
            <el-upload v-if="!readOnly"
                       class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
                       :action="getUploadActionUrl('/admin/app/activity/upload')"
                       :data="{fieldName: 'siteImages', asImage: true}"
                       :on-success="onSiteImagesUploadSuccess"
                       :on-remove="onSiteImagesRemoveFile"
                       :before-upload="pictureFile"
                       :on-error="onUploadError"
                       :show-file-list="true"
                       :on-preview="handlePreview"
                       :limit="flowActivityForm.siteImages.impl.maxCount"
                       :on-exceed="onUploadLimit"
                       :file-list="flowActivityForm.siteImages.impl.fileList"
                       list-type="picture">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <template v-else>
              <el-image v-for="item in parseUploadData(formData.Activity.siteImages, {id: formData.Activity.id,
                  fieldName: 'siteImages', asImage: true})"
                        :preview-src-list="getPictureList(formData.Activity.siteImages, {id: formData.Activity.id, fieldName: 'siteImages', asImage: true})"
                        class="table-cell-image" :key="item.url" :src="item.url" fit="scale-down">
                <div slot="error" class="table-cell-image">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
          </el-form-item>

        </el-col>
        <el-col :span="12">
          <el-form-item label="附件" prop="Activity.attachedFiles">
<!--            <el-upload v-if="!readOnly" name="uploadFile" :headers="getUploadHeaders" multiple-->
<!--              :action="getUploadActionUrl('/admin/app/activity/upload')"-->
<!--              :data="{fieldName: 'attachedFiles', asImage: false}"-->
<!--              :on-success="onAttachedFilesUploadSuccess"-->
<!--              :on-remove="onAttachedFilesRemoveFile"-->
<!--              :on-error="onUploadError" :on-exceed="onUploadLimit"-->
<!--              :limit="flowActivityForm.attachedFiles.impl.maxCount"-->
<!--              :file-list="flowActivityForm.attachedFiles.impl.fileList"-->
<!--              :show-file-list="true">-->
<!--              <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>-->
<!--            </el-upload>-->
<!--            <template v-else>-->
<!--              <a v-for="item in flowActivityForm.attachedFiles.impl.fileList" :key="item.url"-->
<!--                href="javascript:void(0);" @click="downloadFile(item.url, item.name)">-->
<!--                {{item.name}}-->
<!--              </a>-->
<!--            </template>-->

            <el-upload name="uploadFile" :headers="getUploadHeaders" multiple v-if="!readOnly"
                       :action="getUploadActionUrl('/admin/app/activity/upload')"
                       :data="{fieldName: 'attachedFiles', asImage: false}"
                       :on-success="onAttachedFilesUploadSuccess"
                       :on-remove="onAttachedFilesRemoveFile"
                       :on-error="onUploadError" :on-exceed="onUploadLimit"
                       :limit="flowActivityForm.attachedFiles.impl.maxCount"
                       :file-list="flowActivityForm.attachedFiles.impl.fileList"
                       :show-file-list="false">
              <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>
            </el-upload>
            <div v-if="flowActivityForm.attachedFiles.impl.fileList && flowActivityForm.attachedFiles.impl.fileList[0] != null" style="position: relative">
              <div v-for="(item,index) in flowActivityForm.attachedFiles.impl.fileList" :key="item.url"
                   style="display:flex;margin-top: 5px;">
                <div> {{item.name}}</div>
                <div style="margin-left: 15px;display: inline-flex">

                  <el-button type="primary" @click="downloadFile(item.url, item.name)">下载</el-button>
                  <el-button type="primary" @click="previewFile(item.url, item.filename)">预览</el-button>
                  <el-button type="primary" v-if="!readOnly"
                             @click="deleteAttachedFiles(item,flowActivityForm.attachedFiles.impl.fileList,index)">删除</el-button>
                </div>

              </div>
            </div>
            <template v-else>
              <a v-for="item in flowActivityForm.attachedFiles.impl.fileList" :key="item.url"
                 href="javascript:void(0);" @click="downloadFile(item.url, item.name)">
                {{item.name}}
              </a>
            </template>

          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />

  </div>
</template>

<script>
import { mapActions } from 'vuex';
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
import flowMixins from '../../mixins/flowMixins.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { ActivityController, DictionaryController } from '@/api';
import { FlowOperationController } from '@/api/flowController.js';

const processDefinitionKey = 'flowActivity';

export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  name: 'flowActivityForm',
  props: {
    // 是否运行时任务
    isRuntimeTask: {
      type: [Boolean, String]
    },
    // 是否草稿
    isDraft: {
      type: [Boolean, String],
      default: false
    },
    // 是否只读
    readOnly: {
      type: Boolean,
      default: false
    },
    // 流程实例id
    processInstanceId: {
      type: String
    },
    // 抄送消息id
    messageId: {
      type: String
    },
    // 当前任务实例id
    taskId: {
      type: String
    },
    // 任务变量列表
    taskVariableList: {
      type: Array
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, flowMixins],
  data () {
    return {
      imgViewerVisible: false,
      imgList: [],
      formData: {
        Activity: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          activityContent: undefined,
          effect: undefined,
          participants: undefined,
          siteImages: undefined,
          attachedFiles: undefined,
          areaId: undefined,
          isDatasourceInit: false
        }
      },
      // 保存草稿后返回的taskId
      draftTaskId: undefined,
      // 保存草稿后返回的流程实例ID
      draftProcessInstanceId: undefined,
      rules: {
        'Activity.siteImages': [
          {required: true, message: '请输入现场图片', trigger: 'blur'}
        ],
        'Activity.activityContent': [
          {required: true, message: '请输入活动内容', trigger: 'blur'},
          { min: 50, message: '50字以上', trigger: 'blur' }
        ],
        'Activity.participants': [
          {required: true, message: '请输入参与人数', trigger: 'blur'}
        ]
      },
      flowActivityForm: {
        formFilter: {
        },
        formFilterCopy: {
        },
        participants: {
          impl: new DropdownWidget(this.loadParticipantsDropdownList)
        },
        siteImages: {
          impl: new UploadWidget(1)
        },
        attachedFiles: {
          impl: new UploadWidget(1)
        },
        isInit: false
      }
    }
  },
  methods: {
    // 启动流程
    handlerStart (operation, copyItemList, xml) {
      // 启动并保存草稿后再次提交
      if (this.draftProcessInstanceId != null && this.draftTaskId != null) {
        return this.handlerOperation(operation, copyItemList);
      }
      return new Promise((resolve, reject) => {
        this.$refs.flowActivityForm.validate(valid => {
          if (!valid) return reject();
          this.preHandlerOperation(operation, true, xml).then(res => {
            let formData = this.getMasterData(operation.type, (res || {}).assignee);
            return ActivityController.startAndTakeUserTaskFlowActivity(this, {
              processDefinitionKey: processDefinitionKey,
              taskVariableData: {
                ...formData.taskVariableData,
                latestApprovalStatus: operation.latestApprovalStatus
              },
              flowTaskCommentDto: {
                approvalType: operation.type
              },
              activityDto: {
                ...formData.masterData
              },
              ...formData.relationData,
              copyData: (copyItemList || []).reduce((retObj, item) => {
                retObj[item.type] = item.id;
                return retObj;
              }, {})
            });
          }).then(res => {
            this.$message.success('启动成功！');
            resolve();
          }).catch(e => {
            reject(e);
          });
        });
      });
    },
    // 流程操作
    handlerOperation (operation, copyItemList, xml) {
      return new Promise((resolve, reject) => {
        this.$refs.flowActivityForm.validate(valid => {
          if (!valid) return reject();
          this.preHandlerOperation(operation, this.isDraft, xml).then(res => {
            // 加签、减签操作
            if (operation.type === this.SysFlowTaskOperationType.CO_SIGN || operation.type === this.SysFlowTaskOperationType.SIGN_REDUCTION) {
              return this.submitConsign((res || {}).assignee, operation.type === this.SysFlowTaskOperationType.CO_SIGN);
            }
            // 自由跳
            if (operation.type === this.SysFlowTaskOperationType.FREE_JUMP) {
              return FlowOperationController.freeJump(this, {
                processInstanceId: this.processInstanceId,
                sourceTaskId: this.taskId,
                targetTaskKey: (res || {}).targetTaskKey,
                delegateAssignee: (res || {}).assignee,
                taskComment: (res || {}).message,
                taskVariableData: {
                  latestApprovalStatus: operation.latestApprovalStatus
                }
              });
            }
            // 驳回操作
            if (operation.type === this.SysFlowTaskOperationType.REJECT || operation.type === this.SysFlowTaskOperationType.REJECT_TO_TASK) {
              return FlowOperationController.rejectRuntimeTask(this, {
                processInstanceId: this.processInstanceId,
                taskId: this.taskId,
                targetTaskKey: (res || {}).targetTaskKey,
                taskComment: (res || {}).message,
                taskVariableData: {
                  latestApprovalStatus: operation.latestApprovalStatus
                }
              });
            }
            // 驳回到起点
            if (operation.type === this.SysFlowTaskOperationType.REJECT_TO_START) {
              return FlowOperationController.rejectToStartUserTask(this, {
                processInstanceId: this.processInstanceId,
                taskId: this.taskId,
                taskComment: (res || {}).message,
                taskVariableData: {
                  latestApprovalStatus: operation.latestApprovalStatus
                }
              });
            }
            // 撤销操作
            if (operation.type === this.SysFlowTaskOperationType.REVOKE) {
              this.$confirm('是否撤销此任务？').then(res => {
                return FlowOperationController.rejectHistoricTask(this, {
                  processInstanceId: this.processInstanceId,
                  taskId: this.taskId,
                  taskComment: '任务处理人撤销任务',
                  taskVariableData: {
                    latestApprovalStatus: operation.latestApprovalStatus
                  }
                });
              }).catch(e => {
                return Promise.reject(e);
              });
            }
            let formData = this.getMasterData(operation.type, (res || {}).assignee);
            let params = {
              taskId: this.taskId || this.draftTaskId,
              processInstanceId: this.processInstanceId || this.draftProcessInstanceId,
              flowTaskCommentDto: {
                taskComment: (res || {}).message,
                approvalType: operation.type,
                delegateAssignee: operation.type === this.SysFlowTaskOperationType.TRANSFER ? (res || {}).assignee : undefined
              },
              taskVariableData: {
                ...formData.taskVariableData,
                latestApprovalStatus: operation.latestApprovalStatus
              },
              copyData: (copyItemList || []).reduce((retObj, item) => {
                retObj[item.type] = item.id;
                return retObj;
              }, {})
            }
            // 非只读状态下，提交修改数据
            if (!this.readOnly) {
              // 主表数据
              params.activityDto = {
                ...formData.masterData
              };
              // 关联数据
              params = {
                ...params,
                ...formData.relationData
              };
            }

            return ActivityController.submitUserTaskFlowActivity(this, params);
          }).then(res => {
            this.reloadMessage(this);
            if (operation.type !== this.SysFlowTaskOperationType.CO_SIGN && operation.type !== this.SysFlowTaskOperationType.SIGN_REDUCTION) {
              this.$message.success(operation.label + '成功！');
            }
            resolve();
          }).catch(e => {
            console.log(e);
          });
        });
      });
    },
    // 保存草稿
    handlerDraft () {
      return new Promise((resolve, reject) => {
        let formData = this.getFormDataImpl();
        let params = {
          processDefinitionKey: processDefinitionKey,
          processInstanceId: this.processInstanceId || this.draftProcessInstanceId,
          activityDto: {
            ...formData.masterData
          },
          ...formData.relationData
        }
        ActivityController.startAndSaveDraftFlowActivity(this, params).then(res => {
          this.$message.success('草稿保存成功！');
          this.draftProcessInstanceId = res.data.processInstanceId;
          this.draftTaskId = res.data.taskId;
          resolve();
        }).catch(e => {
          reject(e);
        });
      });
    },
    // 获取表单数据
    getFormDataImpl () {
      // 一对一、一对多、多对多关联数据
      let relationData = {};

      return {
        masterData: {
          ...this.formData.Activity
        },
        relationData: relationData
      }
    },
    // 获取流程表单数据
    getMasterData (operationType, assignee) {
      let taskVariableData;
      if (Array.isArray(this.taskVariableList) && this.taskVariableList.length > 0) {
        taskVariableData = this.taskVariableList.reduce((retObj, item) => {
          retObj[item.variableName] = this.formData.Activity[item.variableName] || '';
          return retObj;
        }, {});
      }
      // 会签操作设置多实例处理人集合
      assignee = (assignee && assignee !== '') ? assignee.split(',') : undefined;
      if (operationType === this.SysFlowTaskOperationType.MULTI_SIGN) {
        if (taskVariableData == null) taskVariableData = {};
        taskVariableData.assigneeList = assignee;
      } else if (operationType === this.SysFlowTaskOperationType.SET_ASSIGNEE) {
        if (taskVariableData == null) taskVariableData = {};
        taskVariableData.appointedAssignee = Array.isArray(assignee) ? assignee.join(',') : undefined;
      }

      return {
        ...this.getFormDataImpl(),
        taskVariableData
      }
    },
    // 初始化流程表单
    initFormData () {
      if (!this.isStartFlow) {
        // 流程办理
        let params = {
          processInstanceId: this.processInstanceId,
          taskId: this.taskId
        }
        let httpCall = null;
        if (this.isDraft || this.isDraft === 'true') {
          // 草稿数据
          httpCall = FlowOperationController.viewDraftData(this, {
            processDefinitionKey: processDefinitionKey,
            processInstanceId: this.processInstanceId
          });
        } else if (this.messageId != null) {
          // 抄送消息
          httpCall = FlowOperationController.viewCopyBusinessData(this, {
            messageId: this.messageId
          });
        } else {
          httpCall = (this.taskId && this.isRuntime) ? ActivityController.viewTaskBusinessDataFlowActivity(this, params) : ActivityController.viewHistoricTaskBusinessDataFlowActivity(this, params)
        }
        httpCall.then(res => {
          this.formData.Activity = { ...res.data };
          this.flowActivityForm.participants.impl.onVisibleChange(true).catch(e => {});
          let siteImagesDownloadParams = {
            id: this.formData.Activity.id,
            fieldName: 'siteImages',
            asImage: true
          }
          this.flowActivityForm.siteImages.impl.fileList = this.parseUploadData(this.formData.Activity.siteImages, siteImagesDownloadParams);
          let attachedFilesDownloadParams = {
            id: this.formData.Activity.id,
            fieldName: 'attachedFiles',
            asImage: false
          }
          this.flowActivityForm.attachedFiles.impl.fileList = this.parseUploadData(this.formData.Activity.attachedFiles, attachedFilesDownloadParams);
          // 获取一对多、多对多数据
          this.refreshFlowActivityForm(true);
        }).catch(e => {});
      } else {
        // 启动流程
      }
    },
    onCancel (isSuccess) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess);
      }
    },
    /**
     * 参与人数下拉数据获取函数
     */
    loadParticipantsDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictParticipantsNumber(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 参与人数选中值改变
     */
    onParticipantsValueChange (value) {
    },
    /**
     * 更新辖区活动表单
     */
    refreshFlowActivityForm (reloadData = false) {
      if (!this.flowActivityForm.isInit) {
        // 初始化下拉数据
      }
      this.flowActivityForm.isInit = true;
    },
    /**
     * 现场图片上传成功
     */
    onSiteImagesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.flowActivityForm.siteImages.impl.onFileChange(file, fileList);
        this.formData.Activity.siteImages = this.fileListToJson(this.flowActivityForm.siteImages.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除现场图片
     */
    onSiteImagesRemoveFile (file, fileList) {
      this.flowActivityForm.siteImages.impl.onFileChange(file, fileList);
      this.formData.Activity.siteImages = this.fileListToJson(this.flowActivityForm.siteImages.impl.fileList);
    },
    /**
     * 附件上传成功
     */
    onAttachedFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.flowActivityForm.attachedFiles.impl.onFileChange(file, fileList);
        this.formData.Activity.attachedFiles = this.fileListToJson(this.flowActivityForm.attachedFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除附件
     */
    onAttachedFilesRemoveFile (file, fileList) {
      this.flowActivityForm.attachedFiles.impl.onFileChange(file, fileList);
      this.formData.Activity.attachedFiles = this.fileListToJson(this.flowActivityForm.attachedFiles.impl.fileList);
    },
    deleteAttachedFiles (file, fileList, index) {
      fileList.splice(index, 1)
      this.onAttachedFilesRemoveFile(file, fileList)
    },
    onUploadError (e, file, fileList) {
      this.$message.error('文件上传失败');
    },
    onUploadLimit (files, fileList) {
      this.$message.error('已经超出最大上传个数限制');
    },
    formInit () {
      this.initFormData();
    },
    closeImgViewer () {
      this.imgViewerVisible = false;
    },
    handlePreview (file) {
      this.imgViewerVisible = true
      this.imgList = []
      this.imgList.push(file.url)
    },
    ...mapActions(['reloadMessage'])
  },
  computed: {
    isStartFlow () {
      return this.processInstanceId == null;
    },
    isRuntime () {
      return typeof this.isRuntimeTask === 'string' ? this.isRuntimeTask === 'true' : this.isRuntimeTask;
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  }
}
</script>
